import { render, staticRenderFns } from "./MakerOnboarding.vue?vue&type=template&id=56b5d844&scoped=true&"
import script from "./MakerOnboarding.vue?vue&type=script&lang=js&"
export * from "./MakerOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./MakerOnboarding.vue?vue&type=style&index=0&id=56b5d844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5d844",
  null
  
)

export default component.exports